/* istanbul ignore file */
// eslint-disable-next-line nebula-rules/check-exist-test-file
import { merge } from 'lodash-es';

export function mergeDeep<TObject, TSource>(object: TObject, source: TSource): TObject & TSource {
  return merge(object, source);
}
